<!--
 * @description: 是否用户显示-页头
 * @Author: Jay
 * @Date: 2026-03-02 13:38:05
 * @LastEditors: Jay
 * @LastEditTime: 2026-03-02 14:08:35
-->
<template>
  <div>
    <!-- 代理-页头 -->
    <agencyPageHeaderModule
      :pageName="pageName"
      :menuIcon="iconUrl"
      v-if="!showHeader"
    />
    <!-- 主菜单-页头 -->
    <pageHeaderModule v-if="showHeader" />
  </div>
</template>

<script>
// 代理-页头
import agencyPageHeaderModule from "./agencyPageHeaderModule.vue";
// 主菜单-页头
import pageHeaderModule from "./pageHeaderModule.vue";
export default {
  // 代理需要参数
  props: {
    // 菜单图片
    menuIcon: {
      // type: String,
      default: require("@/assets/menuApp/icon-menu8.png"),
    },
    // 菜单标题
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 代理 true  商户 false
      showHeader: true,
      //身份 0则是商户 1是代理
      rankType: 0,
      // 图片地址
      iconUrl: "",
    };
  },
  components: {
    agencyPageHeaderModule,
    pageHeaderModule,
  },
  created() {
    //身份 0则是商户 1是代理
    this.rankType = sessionStorage.getItem("saveRankType") || null;
    // console.log(this.rankType);
    if (this.rankType == "1") {
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
  },
  mounted() {},
  methods: {
    init(url) {
      // 页面标题
      let pageTitle = this.$route.meta.title || "";
      switch (pageTitle) {
        case "密码管理":
          this.iconUrl = require("@/assets/menuApp/icon-menu4.png");
          break;
        default:
          this.iconUrl = url;
          break;
      }
    },
  },
  watch: {
    // 监听 菜单图片 / 赋值
    menuIcon: {
      handler(newVal) {
        // console.log(newVal, oldVal);
        this.init(newVal);
      },
      deep: true,
      immediate: true, // 初始化时立即执行
    },
  },
};
</script>

<style lang="scss" scoped></style>
